import { computed } from 'vue'
import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query'

import {
  disableApiAccess,
  enableApiAccess,
  getApiAccess,
  rotateApiAccess
} from '../api'

import { apiAccessKeys } from './keys'

export function useApiAccess() {
  const query = useQuery({
    queryKey: apiAccessKeys.all,
    queryFn: ({ signal }) => getApiAccess({ signal })
  })

  return {
    ...query,
    access: computed(() => query.data.value?.data.data ?? null)
  }
}

function useApiAccessMutation(mutationFn: () => Promise<unknown>) {
  const qc = useQueryClient()

  return useMutation({
    mutationFn,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: apiAccessKeys.all })
    }
  })
}

export const useEnableApiAccess = () => useApiAccessMutation(enableApiAccess)
export const useRotateApiAccess = () => useApiAccessMutation(rotateApiAccess)
export const useDisableApiAccess = () => useApiAccessMutation(disableApiAccess)
